import { useParams } from 'react-router';

import { AxiosResponse } from 'axios';
import { FormikHelpers } from 'formik';
import { enqueueSnackbar } from 'notistack';

import { usePermissionsContext } from 'context/PermissionsContext';
import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { ColunaDinamicaProps } from 'pages/cadastro/loja/types';

export function useMutateColunasDinamicas() {
    const { mutate, isLoading } = useFormMutation<AxiosResponse<ColunaDinamicaProps[]>>();
    const { showError } = useShowError();
    const { id } = useParams();
    const { hasPermission } = usePermissionsContext();

    const onSubmit = (formData: { lojaColunas: ColunaDinamicaProps[] }, formik: FormikHelpers<{ lojaColunas: ColunaDinamicaProps[] }>) => {
        if (!hasPermission(['SECAO_DADOS_ALTERAR'])) {
            showError(null, 'Você não tem permissão para alterar esses dados');

            return;
        }

        mutate(
            {
                url: `/gestao/lojaconfiguracao/list${id ? `/${id}` : ''}`,
                formData: formData.lojaColunas,
                method: 'POST',
                preventSnack: true,
                preventRedirect: !!hasPermission(['SECAO_DADOS_ALTERAR']),
            },
            {
                onSuccess: () => {
                    enqueueSnackbar('Coluna salva com sucesso', { variant: 'success' });

                    formik.resetForm({ values: formData });
                },
                onError: (error) => showError(error, 'Erro ao salvar coluna'),
            },
        );
    };

    return { onSubmit, isLoading };
}
